import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/car-affordability',
  component: () => import('../../routes/CarAffordabilityCalculator.svelte'),
  card: {
    id: 'car-affordability',
    title: 'Car Affordability',
    description: 'Calculate how much car you can afford based on your income, debt, and loan terms.',
    icon: 'directions_car',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/car-affordability',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Car Affordability Calculator – How Much Car Can You Afford?',
    description: 'Free car affordability calculator. Determine how much car you can afford based on your income, monthly debts, down payment, and loan terms. Includes estimated insurance and registration costs.',
  },
};

export default meta;
